import React from 'react';
import styles from './confirmPaymentTemplate.module.css';
import success from '../../../assets/success.png';
import error from '../../../assets/error.png';
const ConfirmPaymentTemplate = (props) => {
  return (
    <>
      {props.confirm ? (
        <div className={styles.confirmPaymentWrapper}>
          <img src={success} alt="" />
          <p>ÐÐ¿Ð»Ð°ÑÐ° Ð¿ÑÐ¾ÑÐ»Ð° ÑÑÐ¿ÐµÑÐ½Ð¾</p>
        </div>
      ) : (
        <div className={styles.confirmPaymentWrapper}>
          <img src={error} alt="" />
          <p>ÐÐ¿Ð»Ð°ÑÐ° Ð½Ðµ Ð¿ÑÐ¾ÑÐ»Ð°</p>
        </div>
      )}
    </>
  );
};

export default ConfirmPaymentTemplate;
